module.exports = __webpack_public_path__ + "img/share_icon.dfa31715.svg";